import {isValidKey} from "../utils/functions";
import {FunnelKey} from "./Keys";
import {HeadersCommon} from "./HeadersCommon";
import {VisibleCell} from "./VisibleCell";
import {MIN_CELL_WIDTH} from "./constants";

export class Funnel {
    static readonly __CLASS__ = 'Funnel';
    static readonly INITIAL_FUNNEL_GROUP_NAME = VisibleCell.NOT_JOINABLE_VALUE;
    static readonly INITIAL_FUNNEL_NAME = '';
    static readonly INITIAL_FUNNEL_SIZE = MIN_CELL_WIDTH;

    private readonly key: FunnelKey;
    private readonly name: string;
    private readonly size: number;
    private readonly group: string;
    private readonly is_hidden: boolean;

    constructor(key: FunnelKey, name: string, size: number, group: string, is_hidden: boolean) {
        this.key = key;
        this.name = name;
        this.size = size;
        this.group = group;
        this.is_hidden = is_hidden;
    }

    get Key() {
        return this.key;
    }

    get Name() {
        return this.name;
    }

    get Size() {
        return this.size;
    }

    get Group() {
        return this.group;
    }

    get IsHidden() {
        return this.is_hidden;
    }

    withName(name: string) {
        return this.clone({name});
    }

    withSize(size: number) {
        return this.clone({size});
    }

    withGroup(group: string) {
        return this.clone({group});
    }

    withIsHidden(is_hidden: boolean) {
        return this.clone({is_hidden});
    }

    private clone(replacement: {
        name?: string;
        size?: number;
        group?: string;
        is_hidden?: boolean;
    }) {
        return new Funnel(
            this.key,
            replacement.name === undefined ? this.name : replacement.name,
            replacement.size === undefined ? this.size : replacement.size,
            replacement.group === undefined ? this.group : replacement.group,
            replacement.is_hidden === undefined ? this.is_hidden : replacement.is_hidden,
        );
    }

    static createDefault(funnel_key: FunnelKey) {
        return new Funnel(funnel_key, Funnel.INITIAL_FUNNEL_NAME, Funnel.INITIAL_FUNNEL_SIZE, Funnel.INITIAL_FUNNEL_GROUP_NAME, false);
    }

    static from(origin: Funnel) {
        return new Funnel(origin.Key, origin.Name, origin.Size, origin.Group, origin.IsHidden);
    }

    static fromJSON(object: any) {
        if (!isValidKey(object.key)) {
            throw new Error("invalid content_key");
        }
        if (typeof object.name !== 'string') {
            throw new Error("invalid name");
        }
        if (typeof object.size !== 'number') {
            throw new Error("invalid size");
        }
        if (typeof object.group !== 'string') {
            throw new Error("invalid group");
        }
        if (typeof object.is_hidden !== 'boolean') {
            throw new Error("invalid is_hidden");
        }

        return new Funnel(object.key, object.name, object.size, object.group, object.is_hidden);
    }

}

export class FunnelHeaders extends HeadersCommon<Funnel> {

    protected cloneHeader(original: Funnel): Funnel {
        return Funnel.from(original);
    }

    get GridTemplateColumns() {
        return this.map(c => {
            return (c.IsHidden ? '7' : c.Size) + 'px'
        }).join(' ')
    }

    get Width() {
        return this.any_headers.reduce((s, f) => {
            return s + (f.IsHidden ? 10 : f.Size) + 10;
        }, 0);
    }

    get HasHidden() {
        return this.any_headers.some(f => f.IsHidden);
    }

    get HiddenKeys() {
        return this.any_headers.filter(f => f.IsHidden).map(f => f.Key);
    }
}
